import Dropdown from "../../Elements/Dropdown/Dropdown";
import Icon from "../../Elements/Icon/Icon.tsx";
import Tooltip from "../../Elements/Tooltip/Tooltip.js";
import apiRequest from "utils/ApiRequest/apiRequest";
import { useNavigate, useLocation } from "react-router-dom";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useUser } from "contexts/userContext/userContext";

const LanguagePicker = ({ className = "", withLabel, textOnly }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { getLanguages, getTextByKey, setLanguage, getLanguage } = useContent();
  const { isLoggedIn } = useUser();

  const handleChange = async (e, itemKey) => {
    const betweenSlashArray = location.pathname.split("/");
    betweenSlashArray[1] = itemKey;
    const newPath = betweenSlashArray.join("/");

    if (isLoggedIn()) {
      await apiRequest(
        "Users",
        "UpdateUserLanguage",
        { culture: itemKey },
        "POST"
      );
    }

    navigate(newPath);
    setLanguage(itemKey);
    window.location.reload(false); // delete it if we need prevent refreshing onlang change
  };

  // Function which filtering the Arabic language from Languages List at the header
  // tempLanguagesListorery implementation!!!
  Object.filter = function (obj) {
    let result = {},
      key,
      text;
    for (key in obj) {
      result[key] = obj[key];
      text = result[key].text;
      result[key].text = text.charAt(0).toUpperCase() + text.slice(1);
    }
    const tempLanguagesList = {
      en: result["en"],
      it: result["it"],
      es: result["es"],
      he: result["he"],
      ru: result["ru"],
      ar: result["ar"],
    };
    return tempLanguagesList;
  };

  return (
    <div className="languages">
      <button className="languages-selector">
        <Dropdown
          className={`image-first ${className}`}
          selectList={Object.filter(getLanguages())}
          handleChange={handleChange}
          isChangeTitle={false}
          title={getTextByKey("languages")}
        >
          <Tooltip tooltipTextKey={"change-language"} top>
            <div className="globe-wrapper">
              {textOnly ? (
                getTextByKey("languages")
              ) : (
                <Icon name="globe" small />
              )}
              {withLabel ? getLanguages()?.[getLanguage()]?.text : null}
              <div className="language-arrow">
                <Icon name="arrow-down-solid" />
              </div>
            </div>
          </Tooltip>
        </Dropdown>
      </button>
    </div>
  );
};

export default LanguagePicker;
